<div
class="send_replay_to_entity my-3"
[ngClass]="{ 'h-auto': formGroup.controls['comment'].value || selectedRecord , 'margin-start': selectedRecord }"
>
<form [formGroup]="formGroup">
  <textarea
    #autoInput
    class="form-control"
    formControlName="comment"
    maxlength="500"
    [placeholder]="selectedRecord && selectedRecord.id ? ('evaluationTasks.updateComment' | translate) + '...' : ('evaluationTasks.addComment' | translate) + '...'"
  ></textarea>
  <div
    class="send_replay_to_entity_fotter"
    *ngIf="formGroup.controls['comment'].value || selectedRecord "
  >
    <div class="d-flex align-items-center">
      <a *ngIf="selectedRecord" class="cancel-btn" (click)="cancel()">
        {{"forms.Cancel" | translate}}
      </a>
      <button mat-raised-button (click)="submit()" color="primary">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
        >
          <path
            id="send_ic"
            d="M19.2,3.169a1.545,1.545,0,0,0-2.189-1.756L2.1,8.869a1.544,1.544,0,0,0,0,2.763l14.911,7.456A1.545,1.545,0,0,0,19.2,17.332l-1.561-6.244L8.575,10.25l9.067-.837L19.2,3.169Z"
            transform="translate(-1.25 -1.25)"
            fill="#225c80"
            fill-rule="evenodd"
          />
        </svg>
      </button>
    </div>
  </div>
</form>
</div>
